import React from 'react';

import style from './index.module.scss';

const ZakuoRosneftInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Приглашения на Секции &quot;Закупочные процедуры ПАО &quot;НК &quot;Роснефть&quot;</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис включает в себя:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Отчет позволяет отслеживать количество приглашений предприятий на Секции <br/>
          &quot;Закупочные процедуры ПАО &quot;НК &quot;Роснефть&quot;
        </div>
      </div>
    </div>
  </>
);

export default ZakuoRosneftInfo;
